import { withCn } from '@udecode/cn';
import { PlateElement } from '@udecode/plate-common';

export const ParagraphElement = withCn(PlateElement, 'm-0 px-0 py-1');